import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LabsIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M15.2 1.2c.4 0 .7.2 1 .5v1l-1 1.7V8l.1.4 6 10a2.8 2.8 0 0 1-.1 2.9 3 3 0 0 1-1.2 1c-.4.2-1 .4-1.4.4h-13a3 3 0 0 1-1.6-.4 3 3 0 0 1-1.2-1 2.8 2.8 0 0 1 0-3l5.9-9.9.1-.4V4.4l-1-1.8a1 1 0 0 1 0-1 1 1 0 0 1 1-.4h6.4ZM4.7 19.4a1 1 0 0 0 0 1l.4.3.5.1h13.3l.4-.4a1 1 0 0 0 0-1l-.6-1.2-.3.1c-1.5.4-2.7.3-3.7-.1-1-.5-1.8-1.1-2.5-1.7-1.2-1.1-2.3-2.2-4.4-2.3l-3.1 5.2Zm6.1-15.7.1.4v4.2c0 .4-.1.8-.4 1.2l-1.7 2.8c2.4.5 3.8 1.8 5 2.8.6.6 1.1 1 1.7 1.3a3 3 0 0 0 2.1 0l-4.1-7c-.3-.3-.4-.8-.4-1.3V3.7l.4-.5h-3l.3.5Z" />
  </Icon>
));
export default LabsIcon;
